module.exports = __webpack_public_path__ + "static/media/126-botswana.29fe00ca.svg";